
import i18n from 'i18next'
// import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from '@newageerp/v3.templates.templates-core'
// import XHR from 'i18next-xhr-backend'
import languageEN from './en.json'

i18n
    // .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: languageEN,
        },
        lng: "en",
        fallbackLng: "en",
        debug: true,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        react: {
            bindI18n: 'languageChanged loaded',
            // bindStore: 'added removed',
            nsMode: 'default'
        }
    })

export default i18n;
